import React from "react"
import Link from "./Link"
import PreviewCompatibleImage from "./PreviewCompatibleImage"

const BlogRoll = ({ posts }) => {
  return (
    <div className="blog-roll">
      {posts.map((post) => {
        const image = post.frontmatter.previewImage || post.frontmatter.image
        return (
          <article
            className="blog-list-item tile is-child box notification"
            key={post.id}
          >
            <div className="featured-thumbnail">
              <Link to={post.fields.slug}>
                <PreviewCompatibleImage
                  style={{ borderRadius: "12px" }}
                  imageInfo={{
                    image,
                    alt: `Featured image thumbnail for post ${post.frontmatter.title}`,
                    width: image.childImageSharp.gatsbyImageData.width,
                    height: image.childImageSharp.gatsbyImageData.height,
                  }}
                />
              </Link>
            </div>
            <div>
              <Link to={post.fields.slug}>
                <h6>{post.frontmatter.title}</h6>{" "}
              </Link>
              <p>{post.excerpt}</p>
            </div>
          </article>
        )
      })}
    </div>
  )
}

export default BlogRoll
